<ng-container *ngIf="isSmallScreen; else largeScreen">
    <dx-data-grid 
        id="gridContainer"
        [dataSource]="TSvc.trashMachineInfoDataSource"
        keyExpr="ID"
        [columnAutoWidth]="true"
        [showBorders]="true"
        [remoteOperations]="true"
        [rowAlternationEnabled]="true"
        dataRowTemplate="dataRowTemplateName"
        >

        <dxo-column-chooser [enabled]="true" mode="select"></dxo-column-chooser>

        <dxi-column dataField="Name" [caption]="'name' | translateWithFallback" dataType="string"width="25%"></dxi-column>
        <dxi-column dataField="FenixVersion" [caption]="'version' | translateWithFallback" dataType="string"width="25%"></dxi-column>
        <dxi-column dataField="OwnerId" dataType="string" [caption]="'owner' | translateWithFallback"width="25%">
            <dxo-lookup [dataSource]="OSvc.AllOwners" valueExpr="Id" displayExpr="Name"></dxo-lookup>
        </dxi-column>
        <dxi-column dataField="CurrentStatus" dataType="string" [caption]="'state' | translateWithFallback"width="25%"></dxi-column>

        <tr *dxTemplate="let machineInfo of 'dataRowTemplateName'" role="row"
            [ngClass]="{ 'dx-row-alt': machineInfo.rowIndex % 2 === 0 }">
            <td colspan="4">
                <table width="100%">
                    <tr class="main-row" role="row">
                        <td role="gridcell" width="10%">
                            <dx-button stylingMode="text" (click)="show(machineInfo.rowIndex)">
                                <fa-icon *ngIf="!isShowed[machineInfo.rowIndex]" [icon]="faAngleRight"></fa-icon>
                                <fa-icon *ngIf="isShowed[machineInfo.rowIndex]" [icon]="faAngleDown"></fa-icon>
                            </dx-button>
                        </td>
                        <td role="gridcell" width="50%">{{ machineInfo.data.Name }} ({{ getOwnerName(machineInfo.data.OwnerId) }})</td>
                        <td role="gridcell" width="30%">{{ machineInfo.data.FenixVersion }}</td>
                    </tr>
                    <tr *ngIf="isShowed[machineInfo.rowIndex]">
                        <td colspan="4">
                            <table width="100%">
                                <tr class="main-row" role="row">
                                    <td role="gridcell" colspan="2">{{ machineInfo.data.Name }} ({{
                                        getOwnerName(machineInfo.data.OwnerId) }})</td>
                                    <td role="gridcell" colspan="2">{{ machineInfo.data.FenixVersion }}</td>
                                    <td>
                                        <dx-button [hint]="'trash-machine-info-restore-hint' | translateWithFallback" stylingMode="outlined"
                                            class="m-2" (onClick)="restore(machineInfo.data.Name)">
                                            <fa-icon [icon]="faTrashRestore"></fa-icon>
                                        </dx-button>
                                    </td>
                                </tr>
                                <tr class="notes-row" role="row">
                                    <td role="gridcell" colspan="4">{{ machineInfo.data.CurrentStatus }}</td>
                                </tr>
                            </table>
                        </td>
                    </tr>
                </table>
            </td>
        </tr>

        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-paging [pageSize]="25"> </dxo-paging>
        <dxo-pager [visible]="true" [showInfo]="true" [showNavigationButtons]="true" [showPageSizeSelector]="true"
            [allowedPageSizes]="[10, 25, 50, 100]">
        </dxo-pager>
    </dx-data-grid>
</ng-container>

<ng-template #largeScreen>
    <dx-data-grid 
        id="machineInfoGrid"
        [dataSource]="TSvc.trashMachineInfoDataSource"
        [showBorders]="true"
        [remoteOperations]="false"
        [rowAlternationEnabled]="true"
        [columnHidingEnabled]="true"
        [columnAutoWidth]="true"
        class="p-1"
        >
        <dxi-column dataField="Name" [caption]="'name' | translateWithFallback" dataType="string"></dxi-column>
        <dxi-column dataField="FenixVersion" [caption]="'version' | translateWithFallback"dataType="string" [hidingPriority]="2"></dxi-column>
        <dxi-column dataField="OwnerId" dataType="string" [caption]="'owner' | translateWithFallback">
            <dxo-lookup [dataSource]="OSvc.AllOwners" valueExpr="Id" displayExpr="Name"></dxo-lookup>
        </dxi-column>
        <dxi-column dataField="CurrentStatus" dataType="string" [caption]="'state' | translateWithFallback" [hidingPriority]="0"></dxi-column>
        <dxi-column cellTemplate="selectionCellTemplate" [caption]="'actions' | translateWithFallback" [hidingPriority]="3"></dxi-column>

        <div *dxTemplate="let cellInfo of 'selectionCellTemplate'">
            <dx-button [hint]="'restore' | translateWithFallback" stylingMode="outlined"
                class="m-2" (onClick)="restore(cellInfo.data.Name)">
                <fa-icon [icon]="faTrashRestore"></fa-icon>
            </dx-button>
        </div>

        <dxo-filter-panel [visible]="true"></dxo-filter-panel>
        <dxo-filter-row [visible]="true"></dxo-filter-row>
        <dxo-header-filter [visible]="true"></dxo-header-filter>
        <dxo-search-panel [visible]="true"></dxo-search-panel>
        <dxo-sorting mode="multiple"></dxo-sorting>
        <dxo-scrolling rowRenderingMode="virtual" mode="infinite"> </dxo-scrolling>
        <dxo-paging [pageSize]="25"> </dxo-paging>
        <dxo-pager [visible]="true" [showInfo]="true" [showNavigationButtons]="true"></dxo-pager>
    </dx-data-grid>
</ng-template>